(function () {
  const bundle = document.querySelector('[data-pdp-block-bundle-products]');
  const form = document.querySelector('product-form form[action*="/cart/add"]');
  if (!bundle || !form) return;

  const isPhytonic = bundle.hasAttribute('data-phytonic');
  const money = cents => formatMoney(cents, MinimogSettings.money_format);
  const active = () => bundle.querySelector('[data-bundle-item].is-active');

  function currentVariant() {
    const id = Number(form.querySelector('[name="id"]')?.value);
    const data = document.querySelector('[data-pdp-bundle-main-variants]');
    if (!id || !data) return null;

    try {
      return JSON.parse(data.textContent).find(
        variant => Number(variant.id) === id
      );
    } catch {
      return null;
    }
  }

  function totals(type, el, variant) {
    const price = Number(variant.price);

    if (isPhytonic) {
      const quantity = Number(el.dataset.quantity || 1);
      const discount = Number(el.dataset.discountPercent || 0);
      const compare = price * quantity;

      return {
        price: Math.round(compare * (100 - discount) / 100),
        compare
      };
    }

    if (type === 'starter') {
      return {
        price,
        compare: Number(variant.compare_at_price || price)
      };
    }

    const compare = price + Number(el.dataset.extraPrice || 0);

    return {
      price: Math.round(compare * 0.9),
      compare
    };
  }

  function updateMainPrice(variant) {
    const item = active();
    const wrapper = document.querySelector('[id^="Price-"]');
    if (!item || !wrapper) return;

    const type = item.dataset.package;
    const el = bundle.querySelector(
      `[data-bundle-price][data-package="${type}"]`
    );
    if (!el) return;

    const value = totals(type, el, variant);
    const root = wrapper.querySelector('.m-price');
    if (!root) return;

    const regular = wrapper.querySelector(
      '.m-price__regular .m-price-item--regular'
    );
    const sale = wrapper.querySelector(
      '.m-price__sale .m-price-item--sale'
    );
    const compare = wrapper.querySelector(
      '.m-price__sale .m-price-item--regular'
    );
    const badge = wrapper.querySelector('.m-price__badge-sale');
    const badgeText = badge?.querySelector('.m-product-tag');
    const onSale = value.compare > value.price;

    root.classList.toggle('m-price--on-sale', onSale);

    if (regular) regular.textContent = money(value.price);
    if (sale) sale.textContent = money(value.price);
    if (compare) {
      compare.textContent = onSale ? money(value.compare) : '';
    }
    if (badge) badge.hidden = !onSale;

    if (badgeText && onSale) {
      badgeText.textContent =
        `SAVE ${Math.round(
          (value.compare - value.price) * 100 / value.compare
        )}%`;
    }
  }

  function updatePrices(variant) {
    if (!variant) return;

    bundle.querySelectorAll('[data-bundle-price]').forEach(el => {
      const type = el.dataset.package;
      const value = totals(type, el, variant);
      const save = bundle.querySelector(
        `[data-bundle-save][data-package="${type}"]`
      );
      const onSale = value.compare > value.price;

      el.innerHTML = onSale
        ? `${money(value.price)} <s>${money(value.compare)}</s>`
        : money(value.price);

      if (!save) return;

      save.hidden = !onSale;

      if (!onSale) {
        save.textContent = '';
        return;
      }

      const percent = isPhytonic
        ? Number(el.dataset.discountPercent || 0)
        : type === 'starter'
          ? Math.round(
              (value.compare - value.price) * 100 / value.compare
            )
          : 10;

      save.textContent = `Save ${percent}%`;
    });

    updateMainPrice(variant);
  }

  function setPhytonicQuantity(item) {
    if (!isPhytonic || !item) return;

    const quantity = Number(item.dataset.quantity || 1);
    const input = form.querySelector('[name="quantity"]');
    if (!input) return;

    input.value = quantity;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('change', event => {
    const input = event.target.closest(
      '[data-pdp-block-bundle-products] input[type="radio"]'
    );

    if (!input) return;

    const item = input.closest('[data-bundle-item]');

    bundle.querySelectorAll('[data-bundle-item]').forEach(el => {
      el.classList.remove('is-active');
    });

    item?.classList.add('is-active');

    setPhytonicQuantity(item);
    updatePrices(currentVariant());
  });

  MinimogEvents.subscribe(
    MinimogTheme.pubSubEvents.variantChange,
    event => {
      if (event.data?.variant) {
        updatePrices(event.data.variant);
      }
    }
  );

  form.addEventListener(
    'submit',
    async event => {
      if (isPhytonic) return;

      const item = active();

      if (!item || item.dataset.package === 'starter') return;

      const lines = [...item.querySelectorAll('[data-bundle-line]')];

      if (!lines.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const mainId = Number(
        form.querySelector('[name="id"]')?.value
      );

      const quantity = Number(
        form.querySelector('[name="quantity"]')?.value || 1
      );

      const button = form.querySelector('[type="submit"]');
      const message = bundle.querySelector('[data-bundle-message]');

      if (!mainId) return;

      const required = [
        {
          id: mainId,
          quantity
        },
        ...lines
          .map(line => ({
            id: Number(line.dataset.variantId),
            quantity: Number(line.dataset.quantity || 1)
          }))
          .filter(line => line.id)
      ];

      button?.classList.add('m-spinner-loading');

      if (message) {
        message.textContent = '';
      }

      try {
        const cart = await fetch('/cart.js').then(response => {
          if (!response.ok) {
            throw new Error('Cannot read cart.');
          }

          return response.json();
        });

        const items = required.reduce((result, requiredItem) => {
          const current = cart.items.reduce(
            (qty, cartItem) =>
              Number(cartItem.variant_id) === requiredItem.id
                ? qty + Number(cartItem.quantity)
                : qty,
            0
          );

          if (current < requiredItem.quantity) {
            result.push({
              id: requiredItem.id,
              quantity: requiredItem.quantity - current
            });
          }

          return result;
        }, []);

        if (!items.length) {
          if (MinimogSettings.enable_cart_drawer) {
            document.querySelector('m-cart-drawer')?.open();
          }
          return;
        }

        const sections = [];

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections }
          })
        );

        const config = fetchConfig();

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        config.body = JSON.stringify({
          items,
          sections,
          sections_url: location.pathname
        });

        const response = await fetch(
          MinimogSettings.routes.cart_add_url,
          config
        );

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
            result.message ||
            'Cannot add bundle to cart.'
          );
        }

        MinimogEvents.emit(
          MinimogTheme.pubSubEvents.cartUpdate,
          {
            cart: result,
            productVariantId: mainId
          }
        );

        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: { product: result }
          })
        );

        if (MinimogSettings.enable_cart_drawer) {
          document.querySelector('m-cart-drawer')?.open();
        }
      } catch (error) {
        if (message) {
          message.textContent =
            error.message ||
            'Cannot add bundle to cart. Please try again.';
        }
      } finally {
        button?.classList.remove('m-spinner-loading');
      }
    },
    true
  );

  updatePrices(currentVariant());
})();